import { Injectable, inject } from '@angular/core';
import { ChartSeries, WdxNumberService } from '@wdx/shared/utils';
import { SeriesOptionsType, XAxisOptions } from 'highcharts';
import { DateTime } from 'luxon';

@Injectable()
export class PortfolioPerformanceComponentService {
    private numberService = inject(WdxNumberService);

    public convertChartSeriesToHighchartFormat(
        seriesValues: ChartSeries[] | undefined | null,
        currencyCode: string | undefined,
        type = 'spline',
    ): SeriesOptionsType[] {
        if (!seriesValues) {
            return [];
        }
        return (seriesValues?.map((seriesValue) => {
            return {
                name: seriesValue.name,
                data: seriesValue.data?.map((dataItem) => {
                    return {
                        y: dataItem,
                        custom: {
                            tooltip: {
                                series: seriesValue.name,
                                value: this.numberService.formatCurrency(
                                    dataItem,
                                    {
                                        currencyCode: currencyCode as string,
                                    },
                                ),
                            },
                        },
                    };
                }),
                type,
            };
        }) || []) as SeriesOptionsType[];
    }

    public createHighChartXAxis(dates?: string[]): XAxisOptions {
        return {
            categories: dates?.map((date) =>
                DateTime.fromISO(date as unknown as string).toFormat('MMM yy'),
            ),
        };
    }
}
